import { ITranslations } from 'types/common';
import { ReviewsTableTransFields } from './types';
import en from 'translations/en/reviewsTable.json';
import pl from 'translations/pl/reviewsTable.json';
import sl from 'translations/sl/reviewsTable.json';

export const reviewsTableTranslations: ITranslations<ReviewsTableTransFields> = {
  name: 'reviewsTable',
  en,
  pl,
  sl,
};
